/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveForwardIcon32Regular = forwardRef('TimeClockMoveForwardIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M13.821 5.218A11 11 0 0 1 25.798 11H22.5a1 1 0 1 0 0 2h5a1.5 1.5 0 0 0 1.5-1.5V6a1 1 0 1 0-2 0v3.072a13 13 0 1 0 .905 12.15 1 1 0 0 0-1.832-.803A11 11 0 1 1 13.821 5.218Z" }),
        React.createElement("path", { d: "M16 9.75a1 1 0 1 0-2 0v5.264a3 3 0 0 0 1.658 2.683l4.395 2.197a1 1 0 1 0 .894-1.788l-4.394-2.198a1 1 0 0 1-.553-.894V9.75Z" })));
});
